<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = usePage().props
const startsIn = props["startsIn"] as number // seconds until the session opens, computed server-side
const startDate = props["startDate"] as string // session open date, formatted server-side (d/m/Y)
const startTime = props["startTime"] as string // session open time, formatted server-side (H:i)

// Count down from the server-provided duration using a monotonic clock (not the
// wall clock), so a client whose time drifts from the server can't make the timer
// jump straight to zero — which previously caused an endless reload loop.
const startedAt = performance.now()
const remaining = ref(startsIn)

let timer: number | undefined

function plural(n: number, one: string, many: string): string {
    return `${n} ${n === 1 ? one : many}`
}

const breakdown = computed(() => {
    const s = Math.max(0, Math.round(remaining.value))
    const days = Math.floor(s / 86_400)
    const hours = Math.floor((s % 86_400) / 3_600)
    const minutes = Math.floor((s % 3_600) / 60)
    const seconds = s % 60

    return [
        plural(days, 'giorno', 'giorni'),
        plural(hours, 'ora', 'ore'),
        plural(minutes, 'minuto', 'minuti'),
        plural(seconds, 'secondo', 'secondi'),
    ].join(', ')
})

onMounted(() => {
    timer = window.setInterval(() => {
        remaining.value = startsIn - (performance.now() - startedAt) / 1_000

        // The session is now open: let the server re-render the live app.
        if (remaining.value <= 0) {
            window.location.reload()
        }
    }, 1_000)
})

onBeforeUnmount(() => {
    clearInterval(timer)
})
</script>

<template>
    <div class="col items-center justify-center size-full gap-20 p-10 text-center">
        <h1 class="text-2xl font-bold text-blue">
            La sessione inizia il {{ startDate }} alle ore {{ startTime }}
        </h1>
        <p class="text-sm text-gray-dark max-w-175">
            Mancano {{ breakdown }}.
        </p>
    </div>
</template>

<style scoped>
</style>
